export default __webpack_public_path__ + "static/media/arrow-left.e0a70a48.svg";